module.exports = __webpack_public_path__ + "static/media/project-1.50a83fd8.png";